var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"livedata-layout"},[(_vm.hasDescription)?_c('p',{staticClass:"livedata-layout-description",attrs:{"id":_vm.descriptionId}},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),_c('keep-alive',[(_vm.layoutComponent)?_c(_vm.layoutComponent,{tag:"component",attrs:{"aria-describedby":_vm.descriptionId}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }